import React from 'react';
import { CourseActions, SettingsActions, WebinarActions } from 'actions';
import { SettingsStore, WebinarStore } from 'stores';
import debounce from 'oxygen-debounce';
import PageModule from 'components/PageModule';
import { RaisedButton, TextField, Toggle } from 'material-ui';
import { mixin, RefluxMixin } from 'Util';
import MaterialDropDown from 'components/Material/DropDown';

const styles = {
  root: {
    background: '#f5f5f5',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 40,
  },
  editContainer: {
    background: '#f5f5f5',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    margin: 40,
  },
  fullScreen: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
  },
  box: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  },
  webinarTitle: {
    textAlign: 'center',
    fontSize: 25,
    marginTop: 15,
  },
  input: {
    width: '100%',
  },
  dropdown: {
    display: 'flex',
    alignSelf: 'baseline',
    height: '100px'
  },
  webinarDescription: {
    textAlign: 'center',
    fontSize: 15,
    marginTop: 15,
    marginBottom: 30
  },
  enter: {
    width: '65%',
    marginBottom: 15,
  }
};

class WebinarModule extends mixin(
  RefluxMixin,
  PageModule
) {
  constructor(props) {
    super(props);
    const { params: { caption } } = props;

    this.state = {
      description: (caption && caption.main) || '',
      roomName: (caption && caption.name) || '',
      zroom: null,
      zroomUrl: null,
      fullScreen: false,
      isWebinar: caption ? caption.isWebinar : true,
    }
  }

  saveCaption = debounce(() => {
    const { moduleId } = this.props;
    const { description, roomName, isWebinar } = this.state;

    CourseActions.updatePageModule(this.props.moduleId, {
      id: moduleId,
      params: {
        caption: {
          main: description,
          name: roomName,
          isWebinar: isWebinar,
        }
      },
    });
  }, 1000);

  listenToStores() {
    this.listenToStore(SettingsStore);
    this.listenToStore(WebinarStore);
  }

  componentWillMount() {
    if (super.componentWillMount) {
      super.componentWillMount();
    }
    SettingsActions.read();
  }

  listenToActions() {
    this.listenToAction(SettingsActions.readComplete, (data) => {
      this.setState({ zroom: data.zroom, userEmail: data.email })
    });
    this.listenToAction(WebinarActions.initComplete, (data) => {
      this.setState({ zroomUrl: data });
      const webinar = document.getElementById('webinar');
      webinar.setAttribute('allow', 'microphone *; camera *;');
      webinar.src = webinar.src;
    });
  }

  handleChange(event, prop) {
    if (prop === 'description') {
      this.setState({ description: event.target.value });
    } else {
      this.setState({ roomName: event.target.value });
    }
    this.saveCaption(event, prop)
  }

  initWebinarRoom(moduleId, ownerName, isWebinar) {
    const { zroom, userEmail } = this.state;
    const coursioCreds = zroom ? typeof zroom.useCoursio === "boolean" ? zroom.useCoursio : true : true;
    const isSettingsFilled = coursioCreds || (zroom.domain && zroom.user && zroom.secret);
    const id = isSettingsFilled && (zroom.useCoursio ? `webinar-${moduleId}` : zroom.domain && `${zroom.domain}/webinar-${moduleId}`);
    WebinarActions.initWebinar(id, isWebinar, userEmail === ownerName, true, coursioCreds);
  }

  statusChange(event, prop) {
    this.setState({ isWebinar: event.target.value });
    this.saveCaption(event, prop)
  };

  renderEditMode() {
    const {
      ...other
    } = this.props;
    const { isWebinar, roomName, description } = this.state;
    return (
      <div {...other} style={styles.editContainer}>
        <div style={styles.webinarTitle}>
          Webinar
        </div>
        <TextField
          style={styles.input}
          value={roomName}
          floatingLabelText={this.context.getIntlMessage('webinar.roomName')}
          onChange={e => this.handleChange(e, 'roomName')}
        />
        <TextField
          style={styles.input}
          value={description}
          floatingLabelText={this.context.getIntlMessage('webinar.description')}
          onChange={e => this.handleChange(e, 'description')}
        />
        <div style={styles.dropdown}>
          <MaterialDropDown
            onChange={e => this.statusChange(e, 'isWebinar')}
            label={this.context.getIntlMessage('webinar.isWebinar')}
            selectedIndex={isWebinar ? 0 : 1}
            menuItems={[
              {
                payload: true,
                text: 'Webinar'
              },
              {
                payload: false,
                text: 'Conference'
              }
            ]}
          />
        </div>
      </div>
    );
  }

  fullScreen() {
    document.getElementById('webinar').requestFullscreen();
  }

  renderDetailMode() {
    const { roomName, description, zroom, zroomUrl, isWebinar } = this.state;
    const { moduleId, ownerName, ...other } = this.props;
    const coursioCreds = zroom ? typeof zroom.useCoursio === "boolean" ? zroom.useCoursio : true : true;
    const isSettingsFilled = zroom && (coursioCreds || (zroom.domain && zroom.user && zroom.secret));

    return (
      <div {...other} style={styles.root}>
        <div style={styles.webinarTitle}>
          {roomName}
        </div>
        <div style={styles.webinarDescription}>
          {description}
        </div>
        {
          !zroomUrl ?
            <RaisedButton
              style={styles.enter}
              backgroundColor={'#02c9cc'}
              disabled={!isSettingsFilled}
              label={this.context.getIntlMessage('webinar.enter')}
              secondary
              onTouchTap={() => this.initWebinarRoom(moduleId, ownerName, isWebinar)}
            />
          :
            <RaisedButton
              style={styles.enter}
              backgroundColor={'#02c9cc'}
              label={this.context.getIntlMessage('webinar.fullScreen')}
              secondary
              onTouchTap={() => this.fullScreen()}
            />
        }
        {
          !isSettingsFilled &&
          <div style={styles.webinarDescription}>
            {this.context.getIntlMessage('webinar.missedSettings')}
          </div>
        }
        {
          zroomUrl &&
          <iframe src={zroomUrl && zroomUrl}
                  id={'webinar'}
                  width="100%" height="500"
                  allowFullScreen
          >
          </iframe>
        }
      </div>
    );
  }
}

export default WebinarModule;



// WEBPACK FOOTER //
// ./src/js/components/Page/Module/Webinar.js